import { world } from '../languages';
import { AVAILABLE_WORLDS } from '../languages/constants';

const schoolAccount = {
    getData: (user: User) => {
        return user?.profileDetails?.details?.schoolAccount || ({} as SchoolAccount);
    },
    hasSchool: (user: User) => {
        return user?.profileDetails?.details?.schoolAccount?.school_id;
    },
    hasUnviewedVerification: (user: User) => {
        const account = user?.profileDetails?.details?.schoolAccount;

        return Boolean(account && account.role === 'member' && account.is_verified && !account.verify_viewed_at);
    },
    isAdmin: (user: User) => {
        return user?.profileDetails?.details?.schoolAccount?.role === 'master';
    },
    isSchoolWishlistMaster: (user: User) => {
        return schoolAccount.isAdmin(user) && world === AVAILABLE_WORLDS.DE;
    },
    isVerifiedUser: (user: User) => {
        return user?.profileDetails?.details?.schoolAccount?.is_verified;
    }
};

export default schoolAccount;
